import React, { useState } from 'react'

const TONS = ['Dó (C)','Dó# (C#)','Ré (D)','Ré# (D#)','Mi (E)','Fá (F)','Fá# (F#)','Sol (G)','Sol# (G#)','Lá (A)','Lá# (A#)','Si (B)']

export default function TomModal({ cifra, userId, grupoId, onClose, onRegistrar }) {
  const [tomSel, setTomSel] = useState(cifra.tom_ultima_vez || '')
  const [obs, setObs] = useState('')
  const historico = cifra.historico_tons || []

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-sheet" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" onClick={onClose} />

        {/* Info da música */}
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>🎸</div>
          <div style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, fontWeight: 700 }}>{cifra.titulo}</div>
          {cifra.artista && <div style={{ fontSize: 13, color: 'var(--muted)', marginTop: 2 }}>{cifra.artista}</div>}
        </div>

        {/* Tons */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
          {cifra.tom_original && (
            <div style={{ padding: '12px 14px', background: 'rgba(255,255,255,0.04)', borderRadius: 10, border: '1px solid var(--card-border)', textAlign: 'center' }}>
              <div style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.5 }}>Tom original</div>
              <div style={{ fontSize: 22, fontWeight: 800, fontFamily: 'Montserrat, sans-serif', color: 'var(--text)' }}>{cifra.tom_original}</div>
            </div>
          )}
          {cifra.tom_ultima_vez && (
            <div style={{ padding: '12px 14px', background: 'rgba(0,207,255,0.08)', borderRadius: 10, border: '1px solid rgba(0,207,255,0.25)', textAlign: 'center' }}>
              <div style={{ fontSize: 10, color: 'var(--gold)', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 0.5 }}>Última vez</div>
              <div style={{ fontSize: 22, fontWeight: 800, fontFamily: 'Montserrat, sans-serif', color: 'var(--gold)' }}>{cifra.tom_ultima_vez}</div>
            </div>
          )}
        </div>

        {/* Histórico */}
        {historico.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Histórico de tons</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 120, overflowY: 'auto' }}>
              {historico.slice(0, 5).map((h, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 10px', background: 'rgba(255,255,255,0.03)', borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: 'var(--gold)', fontWeight: 700 }}>{h.tom}</span>
                  <span style={{ color: 'var(--muted)' }}>{h.profiles?.nome} · {new Date(h.data_execucao).toLocaleDateString('pt-BR')}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="divider" />

        {/* Registrar novo tom */}
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>Registrar tom desta vez:</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
          {TONS.map(t => (
            <button key={t} onClick={() => setTomSel(t)}
              style={{ padding: '8px 12px', borderRadius: 50, border: `1px solid ${tomSel === t ? 'var(--gold)' : 'var(--card-border)'}`, background: tomSel === t ? 'rgba(0,207,255,0.15)' : 'var(--card-bg)', color: tomSel === t ? 'var(--gold)' : 'var(--muted)', fontWeight: tomSel === t ? 700 : 400, cursor: 'pointer', fontSize: 12, transition: 'all 0.15s' }}>
              {t}
            </button>
          ))}
        </div>

        <input className="input" placeholder="Observação (ex: com cejilha na 2ª)" value={obs}
          onChange={e => setObs(e.target.value)} style={{ marginBottom: 14, fontSize: 13 }} />

        <button className="btn btn-gold btn-block" disabled={!tomSel}
          onClick={() => onRegistrar(tomSel, obs)}
          style={{ height: 48, fontWeight: 700, fontSize: 15, opacity: tomSel ? 1 : 0.5 }}>
          ✓ Registrar tom {tomSel}
        </button>
      </div>
    </div>
  )
}
